import { boot } from "quasar/wrappers";
import { Notify } from "quasar";
export default boot(async ({ app }) => {
  const displayError = (err, step) => {
    if (!step) {
      step = "";
    }
    // console.log("step", step);
    Notify.create({
      type: "negative",
      message: err?.response?.status
        ? err.response.status + " Error " + step
        : "" + " Error " + step,
      progress: true,
    });
  };
  app.config.globalProperties.$displayError = displayError;
});
